<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="irInicio">Inicio</span> > Asignación Tipsters
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="header-row px-4 pt-4 pb-4">
            <!-- Título + descripción -->
            <div class="header-info">
              <h6 class="mb-1">
                {{ esPublicista ? "Tipsters asignados" : "Asignar Tipsters a Publicistas" }}
              </h6>
              <p class="text-sm mb-0" style="color: var(--q-muted);">
                {{ esPublicista
                  ? "Actualmente tiene los siguientes tipsters asignados por el administrador."
                  : "Selecciona un publicista y marca los tipsters que gestionará."
                }}
              </p>
            </div>

            <!-- Selector + botones (solo admin) -->
            <div class="header-controls" v-if="!esPublicista">
              <div class="ctrl-label text-sm mb-1">Publicista</div>
              <div class="ctrl-row">
                <div class="select-wrap">
                  <select class="form-select" v-model="publicistaId">
                    <option value="">-- Selecciona un publicista --</option>
                    <option v-for="p in publicistas" :key="p.id" :value="p.id">
                      {{ p.name }} ({{ p.username }})
                    </option>
                  </select>
                </div>

                <div class="accion-btns" v-if="publicistas.length">
                  <button
                    class="btn-accion"
                    type="button"
                    @click="marcarTodos"
                    title="Marcar todos"
                    :disabled="!publicistaId || !puedeEditar"
                  ><i class="fa fa-check-square"></i></button>

                  <button
                    class="btn-accion"
                    type="button"
                    @click="desmarcarTodos"
                    title="Desmarcar todos"
                    :disabled="!publicistaId || !puedeEditar"
                  ><i class="fa fa-square"></i></button>
                </div>
              </div>

              <div v-if="publicistas.length === 0" class="mt-3 alert alert-secondary text-sm">
                No hay publicistas creados. Crea uno en <b>Usuarios</b> con rol <b>Publicista</b> y vuelve aquí.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid" v-if="publicistaId || esPublicista">

    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-4 card-body">

            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div>
                <h6 class="mb-0">Tipsters</h6>
                <p class="text-sm mb-0 opacity-7" v-if="publicista">
                  Publicista: <b>{{ publicista.name }}</b> ({{ publicista.username }})
                </p>
                <p v-if="!puedeEditar" class="text-xs opacity-7 mb-0">
                  Modo consulta: solo puedes visualizar la asignación.
                </p>
              </div>

              <div class="d-flex gap-2">
                <QBtn variant="cancela" label="Reset" :disabled="!puedeEditar" @click="resetSeleccion" />
                <QBtn variant="confirma" :label="guardando ? 'Guardando...' : 'Guardar'" :loading="guardando" :disabled="guardando || !puedeEditar" @click="guardar" />
              </div>
            </div>

            <div class="table-responsive mb-2">
              <table class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th class="sin-orden" style="width:70px">On</th>
                    <th>Tipster</th>
                  </tr>
                </thead>

                <tbody class="text-sm">
                  <tr v-for="t in tipsters" :key="t.id">
                    <td>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'tp_'+t.id"
                        :checked="seleccionSet.has(Number(t.id))"
                        :disabled="!puedeEditar"
                        @change="toggleTipster(t.id, $event.target.checked)"
                      />

                    </td>
                    <td>
                      <label class="cursor-pointer" :for="'tp_'+t.id">{{ t.nombre }}</label>
                    </td>
                  </tr>

                  <tr v-if="tipsters.length === 0">
                    <td colspan="2">No hay tipsters que mostrar</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="text-sm opacity-7 mb-0">
              Seleccionados: <b>{{ seleccionSet.size }}</b>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import { globalFunctionsMixin } from "@/mixins/globalFunctions.js";

export default {
  name: "AsignacionTipsters",
  mixins: [globalFunctionsMixin],
  computed: {
    permisos() {
      return this.$store.state.auth?.permisos_finales || [];
    },
    can() {
      return (perm) => Array.isArray(this.permisos) && this.permisos.includes(perm);
    },

    // "Publicista" a nivel funcional: puede ver panel publicista.
    esPublicista() {
      // publicista real: NO ve asignación, solo consulta lo suyo (si quieres)
      return this.can("panel_publicista.ver") && !this.can("asignacion_tipsters.ver");
    },
    puedeEditar() {
      return this.can("asignacion_tipsters.guardar");
    },

  },


  data() {
    return {
      publicistas: [],
      publicistaId: "",
      publicista: null,

      tipsters: [],
      asignados: [],
      seleccionSet: new Set(),

      guardando: false,
    };
  },
  watch: {
    publicistaId(nuevo, viejo) {
      if (!nuevo || nuevo === viejo) return;
      this.cargarDetalle();
    },
  },


  methods: {
    irInicio() {
      this.$router.push("/dashboard");
    },

    async cargarPublicistas() {
      try {
        const resp = await this.$store.dispatch("auth/publicistas", {});
        this.publicistas = resp.data || [];
      } catch (e) {
        console.error(e);
        showSwal.methods.showSwal({
          type: "error",
          message: "No se pudieron cargar los publicistas",
          width: 520,
        });
      }
    },

    async cargarDetalle() {
      this.publicista = null;
      this.tipsters = [];
      this.asignados = [];
      this.seleccionSet = new Set();

      if (!this.publicistaId) return;

      try {
        const resp = await this.$store.dispatch("auth/publicistaTipsters", {
          user_id: Number(this.publicistaId),
        });

        this.publicista = resp.publicista || null;
        this.tipsters = resp.tipsters || [];
        this.asignados = resp.asignados || [];

        this.seleccionSet = new Set((this.asignados || []).map(n => Number(n)));
      } catch (e) {
        console.error(e);
        showSwal.methods.showSwal({
          type: "error",
          message: "No se pudo cargar el detalle",
          width: 520,
        });
      }
    },

    toggleTipster(id, checked) {
      const tid = Number(id);
      const s = new Set(this.seleccionSet);
      if (checked) s.add(tid);
      else s.delete(tid);
      this.seleccionSet = s;
    },

    marcarTodos() {
      const s = new Set(this.seleccionSet);
      for (const t of this.tipsters) s.add(Number(t.id));
      this.seleccionSet = s;
    },

    desmarcarTodos() {
      this.seleccionSet = new Set();
    },

    resetSeleccion() {
      this.seleccionSet = new Set((this.asignados || []).map(n => Number(n)));
    },

    async guardar() {
      if (!this.publicistaId) return;

      this.guardando = true;
      try {
        const resp = await this.$store.dispatch("auth/guardaPublicistaTipsters", {
          user_id: Number(this.publicistaId),
          tipster_ids: Array.from(this.seleccionSet),
        });

        if (resp && resp.ok) {
          showSwal.methods.showSwal({
            type: "success",
            message: "Asignación guardada correctamente",
            width: 520,
          });
          await this.cargarDetalle();
        } else {
          showSwal.methods.showSwal({
            type: "error",
            message: "No se pudo guardar la asignación",
            width: 520,
          });
        }
      } catch (e) {
        console.error(e);
        showSwal.methods.showSwal({
          type: "error",
          message: "Error guardando asignación",
          width: 520,
        });
      } finally {
        this.guardando = false;
      }
    },
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);

    if (this.esPublicista) {
      const attrs = this.$store.state.auth?.me?.data?.attributes || {};
      const miUserId = Number(attrs.id || attrs.user_id || 0);

      if (miUserId > 0) {
        this.publicistaId = String(miUserId);
        await this.cargarDetalle();
      } else {
        await this.cargarPublicistas(); // fallback
      }
    } else {
      await this.cargarPublicistas();
    }

  },

};
</script>

<style scoped>
.container-fluid { max-width: 1100px; }

/* ── Header card ──────────────────────────────────── */
.header-row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
}

.header-info {
  flex: 0 0 auto;
  max-width: 360px;
}

.header-controls {
  flex: 1 1 auto;
}

.ctrl-label {
  color: var(--q-muted);
  font-weight: 600;
}

.ctrl-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* ── Select ───────────────────────────────────────── */
.select-wrap {
  position: relative;
  flex: 1 1 auto;
  max-width: 380px;
}

.select-wrap select,
.select-wrap .form-select {
  appearance: none !important;
  -webkit-appearance: none !important;
  background-image: none !important;
  --bs-form-select-bg-img: none !important;
  padding-right: 40px;
  width: 100%;
}

.select-wrap::after {
  content: "";
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 0; height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid var(--q-muted);
  pointer-events: none;
}

/* ── Botones marcar/desmarcar ─────────────────────── */
.accion-btns {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.btn-accion {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid var(--q-border-md);
  background: var(--q-hover);
  color: var(--q-muted);
  cursor: pointer;
  transition: border-color .15s, color .15s, background .15s;
  font-size: 15px;
}

.btn-accion:hover:not(:disabled) {
  border-color: var(--q-gold);
  color: var(--q-gold);
  background: rgba(245, 166, 35, 0.08);
}

.btn-accion:disabled {
  opacity: .35;
  cursor: not-allowed;
}

/* ── Tabla tipsters ───────────────────────────────── */
.table-listado th,
.table-listado td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-listado td:first-child,
.table-listado th:first-child {
  width: 70px;
  text-align: center;
  vertical-align: middle;
}

/* ── Checkboxes ───────────────────────────────────── */
.table-listado .form-check-input {
  width: 20px;
  height: 20px;
  border: 2px solid var(--q-border-md);
  background-color: var(--q-card-alt);
  box-shadow: none;
  accent-color: var(--q-gold);
  cursor: pointer;
}

.cursor-pointer { cursor: pointer; }
</style>
